import React from "react";
import { Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";

const InputField = ({
  name,
  control,
  label,
  iconClass,
  placeholder,
  rules,
  errors,
  keyfilter,
  defaultValue = "",
  helpText = "",
}) => {
  return (
    <div className="field">
      <label htmlFor={name} className="block">
        {label}
      </label>
      <span className=" p-input-icon-right w-full">
        {iconClass && <i className={iconClass} />}
        <Controller
          name={name}
          control={control}
          rules={rules}
          defaultValue={defaultValue}
          render={({ field, fieldState }) => (
            <>
              <InputText
                {...field}
                keyfilter={keyfilter}
                className={`${
                  fieldState.invalid ? "p-invalid" : ""
                } p-inputtext-sm w-full`}
                placeholder={placeholder}
              />
            </>
          )}
        />
      </span>
      {helpText?.length > 0 && (
        <small className="block text-xs">{helpText}</small>
      )}
      {errors[name] && (
        <small className="p-error block">{errors[name].message}</small>
      )}
    </div>
  );
};

export default InputField;
